import { useManualExecution } from "Pages/ReportsAlerts/Reports/@signals"
import { BACKEND_APIS } from "@constants"
import React, { useEffect } from "react"
import { useReportMultipleModalMultipleEdit } from "Pages/ReportsAlerts/Reports/@hooks"
import FrequencyAutocomplete from "Pages/ReportsAlerts/Reports/@components/Frequency"


export default function ReportFrequencyDaysField() {

	const { data, setFrequency } = useReportMultipleModalMultipleEdit("idFrequencyWhen")


	useEffect(() => {
		setFrequency([])
	}, [useManualExecution.value])

	return <FrequencyAutocomplete
		disabled={useManualExecution.value}
		value={data}
		onChange={e => setFrequency(e.target.value)}
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/report/options/frequencyV2`}
	/>
}